module.exports = __webpack_public_path__ + "static/img/champagne.548531f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ceremony/champagne.png
// module id = SgzB
// module chunks = 1